import React, { useState } from 'react';
import '../Styles/GalleryGrid.css';

const GalleryGrid = ({ items = [], type = 'image' }) => {
  const [popupMedia, setPopupMedia] = useState(null);

  const openPopup = (media) => setPopupMedia(media);
  const closePopup = () => setPopupMedia(null);

  return (
    <>
      <div className="Gallery-pop-up-bottom-container-holds-layouts-layout-3-grid">
        {items.map((item, idx) => (
          <div key={idx} className="gallery-grid-media-wrapper" onClick={() => openPopup(item)}>
            {type === 'image' ? (
              <img
                src={item}
                alt={`gallery-${idx}`}
                className="gallery-grid-image"
              />
            ) : (
              <video
                src={item}
                className="gallery-grid-image gallery-grid-video-adjuster"
                muted
                autoPlay
                loop
              />
            )}
          </div>
        ))}
      </div>

      {popupMedia && (
        <div className="gallery-grid-popup-overlay" onClick={closePopup}>
          <div className="gallery-grid-popup-media" onClick={(e) => e.stopPropagation()}>
            {type === 'image' ? (
              <img src={popupMedia} alt="popup" className="gallery-grid-popup-image" />
            ) : (
              <video
                src={popupMedia}
                controls
                autoPlay
                className="gallery-grid-popup-video"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryGrid;
